import { render, staticRenderFns } from "./ui-notification.vue?vue&type=template&id=8e9c375e&"
import script from "./ui-notification.vue?vue&type=script&lang=js&"
export * from "./ui-notification.vue?vue&type=script&lang=js&"
import style0 from "./ui-notification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e9c375e')) {
      api.createRecord('8e9c375e', component.options)
    } else {
      api.reload('8e9c375e', component.options)
    }
    module.hot.accept("./ui-notification.vue?vue&type=template&id=8e9c375e&", function () {
      api.rerender('8e9c375e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/kit/ui-notification/ui-notification.vue"
export default component.exports